'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var ToastContext = react.createContext({
    toasts: [],
    createSuccessToast: function (message, ms, hideCloseButton) {
        return undefined;
    },
    createErrorToast: function (message, ms, hideCloseButton) {
        return undefined;
    },
    createWarningToast: function (message, ms, hideCloseButton) {
        return undefined;
    },
    destroyToast: function (id) { return undefined; },
    destroyAllToasts: function () { return undefined; }
});

exports.default = ToastContext;
//# sourceMappingURL=ToastContext.js.map
